import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#1b215a",
      light: "#4568d2",
      dark: "#0f1540",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#0AACF0",
      light: "#67D2FF",
      dark: "#0080B8",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#ea5050",
      light: "#f98875",
      dark: "#bc2424",
    },
    success: {
      main: "#77ad64",
      light: "#a5d696",
      dark: "#4e7d3a",
    },
    warning: {
      main: "#f7b369",
      light: "#ffc727",
      dark: "#ae840b",
    },
    text: {
      primary: "#333333",
      secondary: "#6c6c6c",
      disabled: "#9e9e9e",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5fa",
      200: "#eaeaea",
      300: "#d9d9d9",
      400: "#adadad",
      500: "#9a9a9a",
      600: "#6c6c6c",
      700: "#444444",
      800: "#333333",
      900: "#1b215a",
    },
    background: {
      default: "#f5f5fa",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: 14,
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontFamily: "'Outfit', sans-serif",
          borderRadius: 10,
        },
        contained: {
          backgroundColor: "#1b215a",
          "&:hover": { backgroundColor: "#0f1540" },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
        variant: "outlined",
      },
    },
    MuiSelect: {
      defaultProps: {
        size: "small",
        variant: "outlined",
      },
    },
    MuiCheckbox: {
      defaultProps: {
        color: "primary",
      },
    },
    MuiRadio: {
      defaultProps: {
        color: "primary",
      },
    },
    MuiPagination: {
      defaultProps: {
        color: "primary",
        shape: "rounded",
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 1px 6px rgba(0, 0, 0, 0.08)",
        },
      },
    },
  },
});
